import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ProductDetails from "./pages/ProductDetails";
import Cart from "./pages/Cart";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Contact from "./pages/Contact";
import OurJourney from "./pages/Journey";
import CategoryPage from "./pages/CategoryPage";
import FloatingContactButton from "./components/FloatingContactButton";
import ScrollToTop from "./components/scrolltoTop";
import Wishlist from "./pages/Wishlist";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/ourjourney" element={<OurJourney />} />
        <Route path="/product/:id" element={<ProductDetails />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/category/:name" element={<CategoryPage />} />
        <Route path="/wishlist" element={<Wishlist />} />
      </Routes>
      <FloatingContactButton/>
      <Footer /> {/* ✅ ADD HERE */}
    </BrowserRouter>
  );
}
console.log(Wishlist);
export default App;